var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(21.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8691 0C22.598 0 24 1.38529 24 3.09375V14.9521C23.9997 16.6604 22.5979 18.0449 20.8691 18.0449H8.78027L1.78125 23.6982C1.37378 24.1007 0.713123 24.1007 0.305664 23.6982C-0.10184 23.2956 -0.10184 22.6419 0.305664 22.2393L7.61035 16.2852C7.806 16.0918 8.07098 15.9825 8.34766 15.9824H20.8691C21.4453 15.9824 21.9128 15.5214 21.9131 14.9521V3.09375C21.9131 2.52426 21.4454 2.0625 20.8691 2.0625H3.13086C2.55456 2.0625 2.08691 2.52426 2.08691 3.09375V14.4365C2.08668 15.0057 1.61988 15.4665 1.04395 15.4668C0.467794 15.4668 0.000236892 15.0058 0 14.4365V3.09375C0 1.38529 1.40197 0 3.13086 0H20.8691ZM18.3652 9.62402C18.9415 9.62406 19.4081 10.0859 19.4082 10.6553C19.4082 11.2247 18.9415 11.6865 18.3652 11.6865H5.84375C5.26747 11.6865 4.79983 11.2247 4.7998 10.6553C4.79986 10.0858 5.26749 9.62402 5.84375 9.62402H18.3652ZM18.2607 5.67188C18.837 5.6719 19.3047 6.13365 19.3047 6.70312C19.3046 7.27253 18.837 7.73435 18.2607 7.73438H5.73926C5.16301 7.73438 4.69539 7.27254 4.69531 6.70312C4.69531 6.13364 5.16296 5.67188 5.73926 5.67188H18.2607Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLg);
export default __webpack_public_path__ + "static/media/Message-lg.093190b15bc42ad7b786a919fe3b9eb1.svg";
export { ForwardRef as ReactComponent };